export default "__VITE_ASSET__BfEUIuR8__"